import { createContext } from 'react';

// Shared display data for workflow step nodes. `connectorColors` maps a connector
// identity (connectorId or connectorNumber) to its accent color, built from the
// runbook's connector list so each connector gets a distinct color. Provided by
// WorkflowBuilder and consumed by the memoized StepNode without importing the
// (very large) WorkflowBuilder.
export const NodeDisplayContext = createContext({ connectorColors: {}, connectorInfo: {} });
